// extracted by mini-css-extract-plugin
export var activeMenu = "br10-s";
export var headerM = "br10-t";
export var lMHeader = "br10-l";
export var lMHeaderClose = "br10-r";
export var lMHeaderContainer = "br10-k";
export var lMHeaderLogo = "br10-m";
export var lMHeaderMenu = "br10-p";
export var lMHeaderRight = "br10-n";
export var lMHeaderRightImg = "br10-o";
export var mHeaderShow = "br10-q";
export var minWidthLimit = "br10-j";